export let socials = [
  {
    "id": 1,
    "alt": "LinkedIn logo",
    "href":'https://www.linkedin.com/in/mario-nezmah/',
    "awesome": 'linkedin-in'
  },
  {
    "id": 2,
    "alt": "Twitter logo",
    "href": 'https://twitter.com/MarioNezmah',
    "awesome": 'twitter'
  },
  {
    "id": 3,
    "alt": "GitHub logo",
    "href": 'https://github.com/mnezmah',
    "awesome": 'github'
  },
  {
    "id": 4,
    "alt": "Facebook logo",
    "href": 'https://www.facebook.com/mario.oxalis',
    "awesome": "facebook-f"
  }
]